module.exports = __webpack_public_path__ + "static/hero-6233472b78f34cc2e9cb10c049ccb4d2.jpg";